import Isotope from 'isotope-layout';

const $ = window.jQuery;

const FileArchive = {
	init() {
		const $module = $('.big-filearchive');

		if (!$module.length) return;

		/**
		 * Show/hide filter
		 */
		$('.show-filter').on('click', function () {
			var $filters = $('#fileFilters');
			var $btnEl = $(this);
			var $btnElText = $btnEl.find('span');
			$btnEl.toggleClass('active');
			if ($btnEl.hasClass('active')) {
				$btnElText.text('Dölj filter');
				$filters.css('display', 'flex').hide().slideDown();
			} else {
				$btnElText.text('Visa filter');
				$filters.slideUp();
			}
		});

		/*
		 * Check if filters should be active or not depending on screen width
		 */
		function check_if_active_filters() {
			var width = $(document).width();
			var $btnEl = $('.show-filter');

			var shouldRun = true;

			if (width < 900 && $btnEl.hasClass('active') && shouldRun == true) {
				$btnEl.trigger('click');
				shouldRun = false;
			}

			if (width > 900 && !$btnEl.hasClass('active') && shouldRun == true) {
				$btnEl.trigger('click');
				shouldRun = false;
			}
		}

		/**
		 * Run on page load and on resize to check if filters should be active or not
		 */
		check_if_active_filters();
		$(window).on('resize', function () {
			check_if_active_filters();
		});

		var buttonFilters = {};
		var buttonFilter;
		// quick search regex
		var qsRegex;

		// Initialize Isotope product-inspo
		var $grid = new Isotope($module[0], {
			// set itemSelector so .grid-sizer is not used in layout
			itemSelector: '.big-filearchive--item',
			percentPosition: true,
			layoutMode: 'masonry',
			// masonry
			masonry: {
				gutter: '.big-filearchive--gutter',
				columnWidth: '.big-filearchive--sizer',
			},
			filter: function () {
				var $this = $(this);
				var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
				var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
				return searchResult && buttonResult;
			},
		});

		// filter items on button click
		$('#fileFilters li a').on('click', function () {
			// remove class current from all items to clear
			$('#fileFilters li a').removeClass('current');
			// add class to clicked item
			$(this).addClass('current');
			var filterValue = $(this).attr('data-filter');

			var $this = $(this);
			// get group key
			var $buttonGroup = $this.parents('#fileFilters');
			var filterGroup = $buttonGroup.attr('data-filter-group');
			// set filter for group
			buttonFilters[filterGroup] = $this.attr('data-filter');
			// combine filters
			buttonFilter = concatValues(buttonFilters);
			// Isotope arrange
			$grid.arrange();

			return false;
		});

		// use value of search field to filter
		var $quicksearch = $('#documentSearchform input[type="search"]').keyup(
			debounce(function () {
				qsRegex = new RegExp($quicksearch.val(), 'gi');
				$grid.arrange();
			})
		);

		// flatten object by concatting values
		function concatValues(obj) {
			var value = '';
			for (var prop in obj) {
				value += obj[prop];
			}
			return value;
		}

		// debounce so filtering doesn't happen every millisecond
		function debounce(fn, threshold) {
			var timeout;
			threshold = threshold || 100;
			return function debounced() {
				clearTimeout(timeout);
				var args = arguments;
				var _this = this;

				function delayed() {
					fn.apply(_this, args);
				}
				timeout = setTimeout(delayed, threshold);
			};
		}
	},
};

export default FileArchive;
